<template>
  <OptionsDisplay
    :value="value"
    :fields="fields"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { identity } from 'lodash'

import OptionsDisplay from '@/components/OptionsDisplay.vue'
import { http } from '@/services/http.js'

export default {
  name: 'OptionsDisplayApi',
  components: {
    OptionsDisplay,
  },
  inheritAttrs: false,
  props: {
    api: String,
    optionsApi: String,
    value: Object,
    getFields: {
      type: Function,
      default() {
        return http.options(
          `/api/${this.optionsApi || this.api}/`
        ).then(response => {
          if (!response.data.actions) {
            this.$bvToast.toast('Showing unformatted data', {title: 'No fields', variant: 'warning'})
            return
          }
          return this.modifyFields(response.data.actions.POST)
        })
      },
    },
    modifyFields: {
      type: Function,
      default: identity, // e.g. fields => ({ ...fields, new_field: {} })
    },
  },
  data() {
    return {
      fields: {},
    }
  },
  watch: {
    api: {
      handler: 'fetchFields',
      immediate: true,
    },
    optionsApi: 'fetchFields',
  },
  methods: {
    async fetchFields() {
      try {
        this.fields = await this.getFields()
      } catch (err) {
        this.$alert.persistent(`${err}\nPlease try reloading the page. Contact customer support if this persists.`, {variant: 'danger'})
        throw err
      }
    },
  }
}
</script>
